"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "fixed z-50 bottom-0 right-0 p-4 w-full flex justify-end"
};
const _hoisted_2 = { class: "max-w-full w-[645px] relative z-20" };
const Alerts_1 = require("../../stores/Alerts");
const Alert_vue_1 = __importDefault(require("./Alert.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AlertList',
    setup(__props) {
        const store = (0, Alerts_1.useAlertsStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(store).alerts.length > 0)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)(["absolute z-10 left-0 bottom-0 h-36 w-full bg-gradient-to-b from-transparent to-black transition-all", (0, vue_2.unref)(store).alerts.length > 0 ? 'opacity-50' : 'opacity-0'])
                    }, null, 2),
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)(vue_2.TransitionGroup, {
                            name: "alert",
                            tag: "div",
                            class: "grid grid-cols-1 gap-5"
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(store).alerts, (alert) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                        key: alert.key,
                                        alert: alert,
                                        class: "transition-all ease-in-out"
                                    }, null, 8, ["alert"]));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
